import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentPropsWithoutRef, ReactElement } from 'react';

import { cn } from '../lib/cn.js';

export type LabelProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

export const Label = ({ className, ...props }: LabelProps): ReactElement => (
  <LabelPrimitive.Root
    className={cn(
      'text-sm font-medium text-text-primary leading-none',
      'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className,
    )}
    {...props}
  />
);
